<style lang="less">
@import "../less/common.less";
@import "./timeSaleAnalysis.less";
.active {
  visibility: hidden;
  height: 0px !important;
}
</style>
<template>
  <el-row type="flex"
          :gutter="20"
          class="timeSaleAnalysis row-bg common-layout"
          justify="space-between">
    <el-col class="common-layout-r"
            id="search-content-h"
            :span="24">
      <div class="search-txt">
        <el-form :label-position="labelPosition"
                 label-width="80px"
                 :model="formLabelAlign">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="日期:"
                            class="common-date-picker">
                <el-date-picker v-model="startTime"
                                type="date"
                                placeholder="开始日期"
                                :picker-options="pickerOptionsStart"
                                :clearable="false"
                                :editable="false"
                                size="medium"
                                @change="changeStart(false)"></el-date-picker>
                <el-date-picker v-model="endTime"
                                type="date"
                                placeholder="结束日期"
                                :picker-options="pickerOptionsEnd"
                                @change="changeEnd(false)"
                                :editable="false"
                                size="medium"
                                :clearable="false"></el-date-picker>
                <div class="picker-ico">至</div>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    v-if="timeFlag">
              <el-form-item label="对比日期:"
                            class="common-date-picker">
                <el-date-picker v-model="startCompTime"
                                type="date"
                                placeholder="开始日期"
                                :picker-options="pickerCompOptionsStart"
                                :clearable="false"
                                :editable="false"
                                size="medium"
                                @change="changeCompStart(false)"></el-date-picker>
                <el-date-picker v-model="endCompTime"
                                type="date"
                                placeholder="结束日期"
                                :picker-options="pickerCompOptionsEnd"
                                @change="changeCompEnd(false)"
                                :editable="false"
                                size="medium"
                                :clearable="false"></el-date-picker>
                <div class="picker-ico">至</div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="区域:">
                <template v-if="deptAreaList.length">
                  <el-select v-model="areaId"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             size="medium"
                             @change="changeArea">
                    <el-option v-for="item in deptAreaList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             size="medium"
                             @change="changeArea">
                    <el-option v-for="item in deptAreaList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="门店:">
                <template v-if="optionsDept.length">
                  <el-select v-model="valueDept"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             :clearable="true"
                             size="medium"
                             @change="selectDeptAll">
                    <el-option v-for="item in optionsDept"
                               :key="item.deptId"
                               :label="item.deptName"
                               :value="item.deptId"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             :clearable="true"
                             size="medium"
                             @change="selectDeptAll">
                    <el-option v-for="item in optionsDept"
                               :key="item.deptId"
                               :label="item.deptName"
                               :value="item.deptId"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="中类:">
                <template v-if="typeList1.length">
                  <el-select v-model="productTypeId1"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             size="medium"
                             @change="changeProductType1">
                    <el-option v-for="item in typeList1"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             size="medium"
                             @change="changeProductType1">
                    <el-option v-for="item in typeList1"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="小类:">
                <template v-if="optionsProductType.length">
                  <el-select v-model="valueProductType"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             size="medium"
                             :clearable="true"
                             @change="selectAll">
                    <el-option v-for="(item,index) in optionsProductType"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             :clearable="true"
                             size="medium"
                             @change="selectAll">
                    <el-option v-for="(item,index) in optionsProductType"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品:">
                <el-input class="productName"
                          v-model="productName"
                          placeholder="请输入产品名称"
                          size="medium"
                          clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="check-btn">
                <!-- <el-button type="text" @click="cleartAll()">清除选择</el-button>
                <el-button type="text" @click="selectAll()">全部选择</el-button>-->
                <el-button type="text"
                           size="small"
                           @click="comperTime">
                  <template v-if="timeFlag">关闭时间段对比</template>
                  <template v-else>对比时间段</template>
                </el-button>
                <el-button class="time-set-btn"
                           type="text"
                           size="small"
                           @click="setTime">时间段设置</el-button>
                <el-button class="export"
                           size="small"
                           @click="exportExcel">导出</el-button>
                <el-button type="primary"
                           size="small"
                           @click="getDataList()">搜索</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="search-content">
        <div>
          <el-table class="table-common comper"
                    :data="tableData"
                    border
                    show-summary
                    :row-class-name="tableRowClassName"
                    :cell-style="cellStyle"
                    highlight-current-row
                    :resizable="false"
                    v-bind:class="{ active:!timeFlag}"
                    :summary-method="getSummaries"
                    id="out-table1">
            <el-table-column label-class-name="product-data-index"
                             type="index"
                             align="center"
                             width="50"></el-table-column>
            <el-table-column prop="timeQuantum"
                             label="时段"
                             width="85"
                             header-align="center"></el-table-column>
            <el-table-column label="客单价"
                             header-align="center">
              <el-table-column prop="salesPrice"
                               label="当前"
                               min-width="80"
                               header-align="center"
                               align="right"
                               sortable></el-table-column>
              <el-table-column prop="salesPriceLast"
                               label="对比"
                               min-width="80"
                               header-align="center"
                               align="right"
                               sortable></el-table-column>
            </el-table-column>
            <el-table-column label="客单量（名次）"
                             header-align="center">
              <el-table-column prop="salesCountOrder"
                               label="当前"
                               min-width="130"
                               header-align="center"
                               align="right"
                               sortable>
                <template slot-scope="scope">
                  {{ scope.row.salesCount }}&nbsp;&nbsp;&nbsp;
                  <el-tag size="small"
                          :key="scope.row.salesCountOrder"
                          type="danger"
                          v-if="scope.row.index!='合计'">{{ scope.row.salesCountOrder }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="salesCountOrderLast"
                               label="对比"
                               min-width="130"
                               header-align="center"
                               align="right"
                               sortable>
                <template slot-scope="scope">
                  {{ scope.row.salesCountLast }}&nbsp;&nbsp;&nbsp;
                  <el-tag size="small"
                          :key="scope.row.salesCountOrderLast"
                          type="danger"
                          v-if="scope.row.index!='合计'">{{ scope.row.salesCountOrderLast }}</el-tag>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="客单总价（名次）"
                             header-align="center">
              <el-table-column prop="salesMoneyOrder"
                               label="当前"
                               min-width="130"
                               header-align="center"
                               align="right"
                               sortable>
                <template slot-scope="scope">
                  {{ scope.row.salesMoney }}&nbsp;&nbsp;&nbsp;
                  <el-tag size="small"
                          :key="scope.row.salesMoneyOrder"
                          type="danger"
                          v-if="scope.row.index!='合计'">{{ scope.row.salesMoneyOrder }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="salesMoneyOrderLast"
                               label="对比"
                               min-width="130"
                               header-align="center"
                               align="right"
                               sortable>
                <template slot-scope="scope">
                  {{ scope.row.salesMoneyLast }}&nbsp;&nbsp;&nbsp;
                  <el-tag size="small"
                          :key="scope.row.salesMoneyOrderLast"
                          type="danger"
                          v-if="scope.row.index!='合计'">{{ scope.row.salesMoneyOrderLast }}</el-tag>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="产品销售数量（名次）"
                             header-align="center">
              <el-table-column prop="salesAmountOrder"
                               label="当前"
                               min-width="130"
                               header-align="center"
                               align="right"
                               sortable>
                <template slot-scope="scope">
                  {{ scope.row.salesAmount }}&nbsp;&nbsp;&nbsp;
                  <el-tag size="small"
                          :key="scope.row.salesAmountOrder"
                          type="danger"
                          v-if="scope.row.index!='合计'">{{ scope.row.salesAmountOrder }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="salesAmountOrderLast"
                               label="对比"
                               min-width="130"
                               header-align="center"
                               align="right"
                               sortable>
                <template slot-scope="scope">
                  {{ scope.row.salesAmountLast }}&nbsp;&nbsp;&nbsp;
                  <el-tag size="small"
                          :key="scope.row.salesAmountOrderLast"
                          type="danger"
                          v-if="scope.row.index!='合计'">{{ scope.row.salesAmountOrderLast }}</el-tag>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="产品销售金额（名次）"
                             header-align="center">
              <el-table-column prop="productMoneyOrder"
                               label="当前"
                               min-width="130"
                               header-align="center"
                               align="right"
                               sortable>
                <template slot-scope="scope">
                  {{ scope.row.productMoney }}&nbsp;&nbsp;&nbsp;
                  <el-tag size="small"
                          :key="scope.row.productMoneyOrder"
                          type="danger"
                          v-if="scope.row.index!='合计'">{{ scope.row.productMoneyOrder }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="productMoneyOrderLast"
                               label="对比"
                               min-width="130"
                               header-align="center"
                               align="right"
                               sortable>
                <template slot-scope="scope">
                  {{ scope.row.productMoneyLast }}&nbsp;&nbsp;&nbsp;
                  <el-tag size="small"
                          :key="scope.row.productMoneyOrderLast"
                          type="danger"
                          v-if="scope.row.index!='合计'">{{ scope.row.productMoneyOrderLast }}</el-tag>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-table class="table-common"
                    :data="tableData"
                    border
                    show-summary
                    :row-class-name="tableRowClassName"
                    :cell-style="cellStyle"
                    :resizable="false"
                    highlight-current-row
                    v-bind:class="{ active:timeFlag}"
                    :summary-method="getSummaries"
                    id="out-table2">
            <el-table-column label-class-name="product-data-index"
                             type="index"
                             align="center"
                             width="50"></el-table-column>
            <el-table-column prop="timeQuantum"
                             label="时段"
                             width="85"
                             header-align="center"></el-table-column>
            <el-table-column prop="salesPrice"
                             label="客单价"
                             min-width="80"
                             header-align="center"
                             align="right"
                             sortable></el-table-column>
            <el-table-column prop="salesCount"
                             label="客单量（名次）"
                             min-width="140"
                             header-align="center"
                             align="right"
                             sortable
                             sort-by="salesCountOrder">
              <template slot-scope="scope">
                {{ scope.row.salesCount }}&nbsp;&nbsp;&nbsp;
                <el-tag size="small"
                        :key="scope.row.salesCountOrder"
                        type="danger"
                        v-if="scope.row.index!='合计'">{{ scope.row.salesCountOrder }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="salesMoney"
                             label="客单总价（名次）"
                             min-width="170"
                             header-align="center"
                             align="right"
                             sortable
                             sort-by="salesMoneyOrder">
              <template slot-scope="scope">
                {{ scope.row.salesMoney }}&nbsp;&nbsp;&nbsp;
                <el-tag size="small"
                        :key="scope.row.salesMoneyOrder"
                        type="danger"
                        v-if="scope.row.index!='合计'">{{ scope.row.salesMoneyOrder }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="salesAmount"
                             label="产品销售数量（名次）"
                             min-width="180"
                             header-align="center"
                             align="right"
                             sortable
                             sort-by="salesAmountOrder">
              <template slot-scope="scope">
                {{ scope.row.salesAmount }}&nbsp;&nbsp;&nbsp;
                <el-tag size="small"
                        :key="scope.row.salesAmountOrder"
                        type="danger"
                        v-if="scope.row.index!='合计'">{{ scope.row.salesAmountOrder }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="productMoney"
                             label="产品销售金额（名次）"
                             min-width="190"
                             header-align="center"
                             align="right"
                             sortable
                             sort-by="productMoneyOrder">
              <template slot-scope="scope">
                {{ scope.row.productMoney }}&nbsp;&nbsp;&nbsp;
                <el-tag size="small"
                        :key="scope.row.productMoneyOrder"
                        type="danger"
                        v-if="scope.row.index!='合计'">{{ scope.row.productMoneyOrder }}</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="width:85%;">
          <!-- <div> -->
          <el-menu default-active="1"
                   class="el-menu-vertical-demo chart-menu"
                   mode="horizontal"
                   active-text-color="#409EFF"
                   text-color="#303133"
                   @select="handleSelect">
            <el-menu-item index="1">
              <span slot="title">客单价</span>
            </el-menu-item>
            <el-menu-item index="2">
              <span slot="title">客单量</span>
            </el-menu-item>
            <el-menu-item index="3">
              <span slot="title">客单总价</span>
            </el-menu-item>
            <el-menu-item index="4">
              <span slot="title">产品销售数量</span>
            </el-menu-item>
            <el-menu-item index="5">
              <span slot="title">产品销售金额</span>
            </el-menu-item>
          </el-menu>
          <!-- </div> -->
          <div id="myChart">
            <div id="myChart1"
                 v-bind:class="{ active:!timeFlag}"
                 :style="{height: '600px'}"></div>
            <div id="myChart2"
                 v-bind:class="{ active:timeFlag}"
                 :style="{height: '600px'}"></div>
          </div>
        </div>
      </div>
    </el-col>
    <!-- 时间段设置弹出框 start -->
    <timeSet isSave
             :valueTimes="valueTimes"
             :timeSetDialogVisible="timeSetDialog"
             @close_timeSet="closeTimeSet"></timeSet>
    <!-- 时间段设置弹出框 end -->
    <el-dialog class="exportDialog"
               :visible.sync="centerDialogVisible"
               width="30%"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               :modal-append-to-body="false"
               center>
      <el-progress class="exportProgress"
                   :text-inside="false"
                   :show-text="false"
                   :stroke-width="16"
                   :percentage="percentage"></el-progress>
      <p>{{percenttxt}}</p>
    </el-dialog>
  </el-row>
</template>
<script>
import deptApi from "@/api/api-dept";
import productApi from "@/api/api-product";
import common from "@/libs/common";
import timeSet from './timeSet.vue'
import { MessageBox } from "element-ui";
// 引入导出Excel表格依赖
import FileSaver from "file-saver";
import XLSX from "xlsx";
import $ from "jquery";

let loading;
export default {
  components: {
    timeSet
  },
  data () {
    return {
      //时间
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      startTime: new Date(common.getPerDate()),
      endTime: new Date(common.getPerDate()),
      labelPosition: "right",
      formLabelAlign: {
        name: "",
        region: "",
        type: ""
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      tableData: [],
      currentTotal: [],
      // 区域
      areaId: ['all'],
      //分类列表
      optionsProductType: [],
      valueProductType: [],
      //商品名称
      productName: null,
      // 对比时间标识
      timeFlag: false,
      // 对比时间
      pickerCompOptionsStart: {},
      pickerCompOptionsEnd: {},
      startCompTime: new Date(),
      endCompTime: new Date(),
      yData: [], //y轴数据
      data1: [], //客单价
      dataComper1: [], //对比客单价
      data2: [], //客单量
      dataComper2: [], //对比客单量
      data3: [], //客单总价
      dataComper3: [], //对比客单总价
      data4: [], //产品销售数量
      dataComper4: [], //对比产品销售数量
      data5: [], //产品销售金额
      dataComper5: [], //对比产品销售金额
      option: 1, // 记录展示那条折线信息
      oldSearchType: ["all"],
      oldSearchDeptType: ["all"],
      optionsDept: [],
      valueDept: [],
      deptAreaList: [],
      oldDeptArea: ["all"],
      oldDept: ["all"],
      typeList1: [],
      productTypeId1: [],
      oldProductType1: ["all"],
      // 时间设置弹出框
      timeSetDialog: false,
      // 时间段设置（当前为1小时、0.5小时）
      valueTimes: 60,
      // 导出弹框
      centerDialogVisible: false,
      percentage: 0,
      percenttxt: "导出数据100条,已处理50条,正在导出,请稍等",
      pictLoading: false,
    };
  },

  methods: {
    closeTimeSet (value) {
      let that = this
      if (value) {
        that.valueTimes = value
        // alert("设置")
        that.getDataList();
        // if (that.radio == "1" || that.radio == "0") {
        //   that.searchProduct()
        // } else if (that.radio == "3") {
        //   // 获取产品出入库明细
        //   that.getProductTypeDetail()
        // }
      }
      that.timeSetDialog = false
    },
    // 设置时间段
    setTime () {
      this.timeSetDialog = true
    },
    // 切换中类 重新请求数据
    changeProductType1 (val) {
      let that = this
      const allValues = [];
      for (const item of that.typeList1) {
        allValues.push(item.productTypeId);
      }
      const oldVal =
        that.oldProductType1.length === 1 ? that.oldProductType1[0] : [];
      if (val.includes("all")) that.productTypeId1 = allValues
      if (oldVal.includes("all") && !val.includes("all"))
        that.productTypeId1 = []
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        that.productTypeId1 = val
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        if (val.length === allValues.length - 1)
          that.productTypeId1 = ["all"].concat(val)
      }
      that.oldProductType1[0] = that.productTypeId1;
      if (that.productTypeId1.length == 0) {
        that.valueProductType = [] // 当前选中分类
        that.optionsProductType = [] // 当前分类列表
        that.oldSearchType = []
      } else {
        let data = { TypeFlag: 0 }
        if (that.productTypeId1[0] !== 'all') { data["typeId"] = that.productTypeId1 }
        common.getProductTypeListByFLag(data).then(
          res => {
            that.optionsProductType = [{ productTypeId: "all", productTypeName: "全选" }].concat(res)
            that.valueProductType = that.optionsProductType.map(item => {
              return item.productTypeId
            })
            that.oldSearchType = ['all']
          },
          err => {
            console.log(err)
          }
        )
      }
    },
    // 切换区域，根据区域获取门店 重新请求数据
    changeArea (val) {
      let that = this
      const allValues = [];
      for (const item of that.deptAreaList) {
        allValues.push(item.id);
      }
      const oldVal =
        that.oldDeptArea.length === 1 ? that.oldDeptArea[0] : [];
      if (val.includes("all")) that.areaId = allValues
      if (oldVal.includes("all") && !val.includes("all"))
        that.areaId = []
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        that.areaId = val
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        if (val.length === allValues.length - 1)
          that.areaId = ["all"].concat(val)
      }
      that.oldDeptArea[0] = that.areaId;

      if (that.areaId.length == 0) {
        that.valueDept = []
        that.productTypeId1 = []
        that.valueProductType = []
        that.optionsDept = []
        that.optionsProductType = []
        that.oldDept = []
        that.oldProductType1 = []
        that.oldSearchType = []
      } else {
        let data = { AreaId: that.areaId[0] === 'all' ? [] : that.areaId }
        common.getDept(data).then(
          res => {
            that.optionsDept = [{ deptId: "all", deptName: "全选" }].concat(res)
            that.valueDept = that.optionsDept.map(item => {
              return item.deptId
            })
            that.oldDept = ['all']
          },
          err => {
            console.log(err)
          }
        )
      }
    },
    selectDeptAll (val) {
      const allValues = [];
      for (const item of this.optionsDept) {
        allValues.push(item.deptId);
      }
      const oldVal =
        this.oldSearchDeptType.length === 1 ? this.oldSearchDeptType[0] : [];
      if (val.includes("all")) this.valueDept = allValues;
      if (oldVal.includes("all") && !val.includes("all")) this.valueDept = [];
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        this.valueDept = val;
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        console.log(11);
        if (val.length === allValues.length - 1)
          this.valueDept = ["all"].concat(val);
      }
      this.oldSearchDeptType[0] = this.valueDept;
    },
    handleSelect (option) {
      let that = this;
      that.option = option;
      that.drawLine();
    },
    comperTime () {
      let that = this;
      let timeFlag = that.timeFlag;
      that.timeFlag = !timeFlag;
      if (that.timeFlag) {
        let iDays = common.datedifference(that.startTime, that.endTime) + 1;
        that.startCompTime = common.getCPerDate(that.startTime, iDays);
        that.endCompTime = common.getCPerDate(that.endTime, iDays);
        //重新请求数据
        // that.getDataList();
      }
      that.getDataList();
    },
    // 给el-select添加change事件
    // oldSearchBankType  存储上一次的值

    selectAll (val) {
      const allValues = [];
      for (const item of this.optionsProductType) {
        allValues.push(item.productTypeId);
      }
      const oldVal =
        this.oldSearchType.length === 1 ? this.oldSearchType[0] : [];
      if (val.includes("all")) this.valueProductType = allValues;
      if (oldVal.includes("all") && !val.includes("all"))
        this.valueProductType = [];
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        this.valueProductType = val;
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        console.log(11);
        if (val.length === allValues.length - 1)
          this.valueProductType = ["all"].concat(val);
      }
      this.oldSearchType[0] = this.valueProductType;

      // let allValues = [];
      // for (const item of this.optionsProductType) {
      //   allValues.push(item.productTypeId);
      // }
      // let oldVal = this.oldSearchType.length === 1 ? this.oldSearchType : [];
      // if (val.includes("all")) {
      //   console.log(allValues);
      //   this.valueProductType = allValues;
      //   oldVal = this.valueProductType;
      // }
      // if (this.oldSearchType.includes("all") && val.includes("all")) {
      //   if (val.length === 1) this.valueProductType = [];
      //   else {
      //     const index = val.indexOf("all");
      //     val.splice(index, 1); // 排除全选选项
      //     this.valueProductType = val;
      //   }
      //   oldVal = this.valueProductType;
      // }
      // if (!this.oldSearchType.includes("all") && !val.includes("all")) {
      //   if (val.length === allValues.length - 1) {
      //     this.valueProductType = ["all"].concat(val);
      //     oldVal = this.valueProductType;
      //   }
      // }
      // this.oldSearchType = oldVal;
    },
    // 清除选择
    // cleartAll() {
    //   let that = this;
    //   that.valueProductType = [];
    // },
    // selectAll() {
    //   let that = this;
    //   that.valueProductType = that.optionsProductType.map(item => {
    //     return item.productTypeId;
    //   });
    // },
    drawLine () {
      let that = this;
      let yData = that.yData;
      let data1 = that.data1;
      let data2 = that.data2;
      let data3 = that.data3;
      let data4 = that.data4;
      let data5 = that.data5;

      let option = that.option;
      let timeFlag = that.timeFlag;
      let legend = null;
      let itemStyle = { normal: { lineStyle: { width: 2.5 } } };
      let data = [];
      let text = "图表";
      // 基于准备好的dom，初始化echarts实例
      let myChart = null;
      if (timeFlag) {
        if (option == 1) {
          text = "客单价对比图表";
          legend = {
            right: 0,
            bottom: 30,
            left: "center",
            data: ["客单价", "对比客单价"]
          };
          data = [
            {
              name: "客单价",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: data1,
              itemStyle: itemStyle
            },
            {
              name: "对比客单价",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: that.dataComper1,
              itemStyle: itemStyle
            }
          ];
        } else if (option == 2) {
          text = "客单量对比图表";
          legend = {
            right: 0,
            bottom: 30,
            left: "center",
            data: ["客单量", "对比客单量"]
          };
          data = [
            {
              name: "客单量",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: data2,
              itemStyle: itemStyle
            },
            {
              name: "对比客单量",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: that.dataComper2,
              itemStyle: itemStyle
            }
          ];
        } else if (option == 3) {
          text = "客单总价对比图表";
          legend = {
            right: 0,
            bottom: 30,
            left: "center",
            data: ["客单总价", "对比客单总价"]
          };
          data = [
            {
              name: "客单总价",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: data3,
              itemStyle: itemStyle
            },
            {
              name: "对比客单总价",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: that.dataComper3,
              itemStyle: itemStyle
            }
          ];
        } else if (option == 4) {
          text = "产品销售数量对比图表";
          legend = {
            right: 0,
            bottom: 30,
            left: "center",
            data: ["产品销售数量", "对比产品销售数量"]
          };
          data = [
            {
              name: "产品销售数量",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: data4,
              itemStyle: itemStyle
            },
            {
              name: "对比产品销售数量",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: that.dataComper4,
              itemStyle: itemStyle
            }
          ];
        } else if (option == 5) {
          text = "产品销售金额对比图表";
          legend = {
            right: 0,
            bottom: 30,
            left: "center",
            data: ["产品销售金额", "对比产品销售金额"]
          };
          data = [
            {
              name: "产品销售金额",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: data5,
              itemStyle: itemStyle
            },
            {
              name: "对比产品销售金额",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: that.dataComper5,
              itemStyle: itemStyle
            }
          ];
        }
        myChart = that.$echarts.init(document.getElementById("myChart1"));
      } else {
        legend = null;
        data = null;
        if (option == 1) {
          text = "客单价图表";
          data = [
            {
              name: "客单价",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: data1,
              itemStyle: itemStyle
            }
          ];
        } else if (option == 2) {
          text = "客单量图表";
          data = [
            {
              name: "客单量",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: data2,
              itemStyle: itemStyle
            }
          ];
        } else if (option == 3) {
          text = "客单总价图表";
          data = [
            {
              name: "客单总价",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: data3,
              itemStyle: itemStyle
            }
          ];
        } else if (option == 4) {
          text = "产品销售数量图表";
          data = [
            {
              name: "产品销售数量",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: data4,
              itemStyle: itemStyle
            }
          ];
        } else if (option == 5) {
          text = "产品销售金额图表";
          data = [
            {
              name: "产品销售金额",
              type: "line",
              symbolSize: 6, //拐点圆的大小
              data: data5,
              itemStyle: itemStyle
            }
          ];
        }
        myChart = that.$echarts.init(document.getElementById("myChart2"));
      }
      let startTime = common.getMonthDay(that.startTime)
      let endTime = common.getMonthDay(that.endTime)
      let startCompTime = common.getMonthDay(that.startCompTime)
      let endCompTime = common.getMonthDay(that.endCompTime)
      let timeStr1 = ""
      let timeStr2 = ""
      if (startTime == endTime) {
        timeStr1 = startTime + " 星期(" + common.getDay(that.startTime) + ")";
      } else {
        timeStr1 = startTime + " 星期(" + common.getDay(that.startTime) + ")~" + endTime + " 星期(" + common.getDay(that.endTime) + ")";
      }
      if (startCompTime == endCompTime) {
        timeStr2 = startCompTime + " 星期(" + common.getDay(that.startCompTime) + ")";
      } else {
        timeStr2 = startCompTime + " 星期(" + common.getDay(that.startCompTime) + ")~" + endCompTime + " 星期(" + common.getDay(that.endCompTime) + ")";
      }
      // let timeStr1 = startTime + " 星期(" + common.getDay(that.startTime) + ")~" + endTime + " 星期(" + common.getDay(that.endTime) + ")";
      // let timeStr2 = startCompTime + " 星期(" + common.getDay(that.startCompTime) + ")~" + endCompTime + " 星期(" + common.getDay(that.endCompTime) + ")";
      // 绘制图表
      myChart.setOption({
        title: {
          text: text,
          // subtext: '数据来自西安兰特水电测控技术有限公司',
          left: "center"
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params, ticket, callback) {
            let str = params[0].name += '<br/>'
            let len = params.length == 1 ? 100 : (100 + (params[1].seriesName.length - 4) * 8)
            for (var i = 0, l = params.length; i < l; i++) {
              str += (('<div style="display:flex;padding-right:8px;"><div style="width:' + len + 'px;text-align: right;padding-right:8px;">' + params[i].marker + params[i].seriesName + " : </div><div>" + params[i].data) + " " + (i == 0 ? timeStr1 : timeStr2)) + '</div></div>';
            }
            return str
          }
        },
        legend: legend,
        grid: {
          left: "3%",
          right: "3%",
          bottom: "100",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          // name: "时段",
          data: yData
        },
        yAxis: {
          type: "value"
        },
        color: ["#e526ec", "#f27233"],
        lineStyle: {
          width: 4 //default value:2
        },
        series: data
      });
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
      } else {
        return "success-row";
      }
      return "";
    },
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 指定列号
        return "color:#4e9bed";
      } else {
        return "";
      }
    },
    changeStart (flag = false) {
      let that = this;
      that.pickerOptionsStart = Object.assign({}, that.pickerOptionsStart, {
        disabledDate: time => {
          return time.getTime() > that.endTime;
        }
      });
      if (that.timeFlag && !flag) {
        let iDays = common.datedifference(that.startTime, that.endTime) + 1;
        that.startCompTime = common.getCPerDate(that.startTime, iDays);
        that.endCompTime = common.getCPerDate(that.endTime, iDays);
        that.getDataList();
      }
    },
    changeEnd (flag = false) {
      let that = this;
      that.pickerOptionsEnd = Object.assign({}, that.pickerOptionsEnd, {
        disabledDate: time => {
          return time.getTime() < that.startTime;
        }
      });
      if (that.timeFlag && !flag) {
        let iDays = common.datedifference(that.startTime, that.endTime) + 1;
        that.startCompTime = common.getCPerDate(that.startTime, iDays);
        that.endCompTime = common.getCPerDate(that.endTime, iDays);
        that.getDataList();
      }
    },
    changeCompStart (flag = false) {
      let that = this;
      that.pickerCompOptionsStart = Object.assign(
        {},
        that.pickerCompOptionsStart,
        {
          disabledDate: time => {
            return time.getTime() > that.endCompTime;
          }
        }
      );
      if (!flag) {
        that.getDataList();
      }
    },
    changeCompEnd (flag = false) {
      let that = this;
      that.pickerCompOptionsEnd = Object.assign({}, that.pickerCompOptionsEnd, {
        disabledDate: time => {
          return time.getTime() < that.startCompTime;
        }
      });
      if (!flag) {
        that.getDataList();
      }
    },
    // 根据分类获取商品
    getProductList (data) {
      return new Promise((resolve, reject) => {
        productApi
          .getProductData(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //商品分类列表
    getProductTypeList () {
      return new Promise((resolve, reject) => {
        productApi
          .getProductTypeList()
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取时间段分析数据
    getDataList (init = false) {
      let that = this;
      if (!that.areaId || that.areaId.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择区域！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      let valueDept = that.valueDept;
      if (!valueDept || valueDept.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择门店！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      if (!that.productTypeId1 || that.productTypeId1.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择中类！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      if (that.valueProductType.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择小类！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      loading = that.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.6)"
      });
      that.tableData = [];
      let startTime = common.getTime(that.startTime) + " 00:00:00";
      let endTime = common.getTime(that.endTime) + " 23:59:59";
      let productInfo = [];
      if (that.productTypeId1[0] != "all" || that.valueProductType[0] != "all") {
        if (that.valueProductType[0] == "all") {
          productInfo = that.optionsProductType
            .filter(item => {
              return item.productTypeId != "all";
            })
            .map(item => {
              return {
                productTypeId: item.productTypeId,
                type: 1,
                productId: []
              };
            });
        } else {
          productInfo = that.valueProductType.map(item => {
            return {
              productTypeId: item,
              type: 1,
              productId: []
            };
          });
        }
      }
      let data = {
        beginDate: startTime,
        endDate: endTime,
        deptId: (that.areaId[0] == "all" && valueDept[0] == "all") ? [] : valueDept.filter(item => item != 'all'),
        //valueDept.length == that.optionsDept.length ? [] : valueDept
        productInfo: productInfo,
        productName: that.productName == null ? "" : that.productName,
        searchMinutes: that.valueTimes
        // 传入商品名称模糊查询
      };
      if (that.timeFlag) {
        let startCompTime = common.getTime(that.startCompTime) + " 00:00:00";
        let endCompTime = common.getTime(that.endCompTime) + " 23:59:59";
        data["compBeginDate"] = startCompTime;
        data["compEndDate"] = endCompTime;
      }
      productApi.getProductSalesTime(data).then(
        res => {
          let yData = []; //y轴数据
          let data1 = []; //客单价
          let data2 = []; //客单量
          let data3 = []; //客单总价
          let data4 = []; //产品销售数量
          let data5 = []; //产品销售金额
          let dataComper1 = []; //对比客单价
          let dataComper2 = []; //对比客单量
          let dataComper3 = []; //对比客单总价
          let dataComper4 = []; //对比产品销售数量
          let dataComper5 = []; //对比产品销售金额
          let timeQuantum = ""; //res.length>1?res[0].timeQuantum + "~" + res[res.length-1].timeQuantum:res[0].timeQuantum;
          that.currentTotal = [];
          if (res.length > 1) {
            // if(that.timeFlag){
            that.tableData = res
              .map((item, index) => {
                item["salesPrice"] = common.formatDecimal1(
                  common.floatDiv(item.salesMoney, item.salesCount) + ""
                );
                if (that.timeFlag) {
                  item["salesPriceLast"] = common.formatDecimal1(
                    common.floatDiv(item.salesMoneyLast, item.salesCountLast) +
                    ""
                  );
                }
                item["timeQuantum2"] = item.timeQuantum;
                if (item.timeQuantum != 100) {
                  item["index"] = index + 1;
                  timeQuantum = item.timeQuantum + "~" + (that.valueTimes == 60 ? (item.timeQuantum + 1) : (item.timeQuantum + 0.5));
                  timeQuantum = timeQuantum.replace('.5', ':30')
                  yData.push(item.timeQuantum);
                  data1.push(item.salesPrice);
                  data2.push(item.salesCount);
                  data3.push(item.salesMoney);
                  data4.push(item.salesAmount);
                  data5.push(item.productMoney);
                  dataComper1.push(item.salesPriceLast);
                  dataComper2.push(item.salesCountLast);
                  dataComper3.push(item.salesMoneyLast);
                  dataComper4.push(item.salesAmountLast);
                  dataComper5.push(item.productMoneyLast);
                  item.timeQuantum = timeQuantum;
                  return item;
                } else {
                  item["index"] = "合计";
                  const firstQuantum = res[0].timeQuantum2;
                  timeQuantum =
                    firstQuantum + "~" + (res[res.length - 2].timeQuantum2 + 1);
                  item.timeQuantum = timeQuantum;
                  if (that.timeFlag) {
                    that.currentTotal.push(item.timeQuantum);
                    that.currentTotal.push(item.salesPrice);
                    that.currentTotal.push(item.salesPriceLast);
                    that.currentTotal.push(item.salesCount);
                    that.currentTotal.push(item.salesCountLast);
                    that.currentTotal.push(item.salesMoney);
                    that.currentTotal.push(item.salesMoneyLast);
                    that.currentTotal.push(item.salesAmount);
                    that.currentTotal.push(item.salesAmountLast);
                    that.currentTotal.push(item.productMoney);
                    that.currentTotal.push(item.productMoneyLast);
                  } else {
                    that.currentTotal.push(item.timeQuantum);
                    that.currentTotal.push(item.salesPrice);
                    that.currentTotal.push(item.salesCount);
                    that.currentTotal.push(item.salesMoney);
                    that.currentTotal.push(item.salesAmount);
                    that.currentTotal.push(item.productMoney);
                  }
                  return null;
                }
              })
              .filter(item => item != null);
          }
          that.yData = yData; //y轴数据
          that.data1 = data1; //客单价
          that.data2 = data2; //客单量
          that.data3 = data3; //客单总价
          that.data4 = data4; //产品销售数量
          that.data5 = data5; //产品销售金额
          that.dataComper1 = dataComper1;
          that.dataComper2 = dataComper2;
          that.dataComper3 = dataComper3;
          that.dataComper4 = dataComper4;
          that.dataComper5 = dataComper5;
          that.drawLine();
          loading.close();
        },
        err => {
          loading.close();
        }
      );
    },
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      const currentTotal = this.currentTotal;
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        } else {
          sums[index] = currentTotal[index - 1];
        }
        // const values = data.map(item => Number(item[column.property]));
        // if (!values.every(value => isNaN(value))) {
        //   sums[index] = values.reduce((prev, curr) => {
        //     const value = Number(curr);
        //     if (!isNaN(value)) {
        //       return prev + curr;
        //     } else {
        //       return prev;
        //     }
        //   }, 0);
        //   sums[index] += "";
        // } else {
        //   sums[index] = "N/A";
        // }
      });

      return sums;
    },
    init () {
      let that = this;
      loading = that.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.6)"
      });
      that.changeStart(true);
      that.changeEnd(true);
      that.changeCompStart(true);
      that.changeCompEnd(true);
      let data = { productTypeId: [] };
      // 获取部门
      Promise.all([
        common.getDept({
          "areaId": []
        }),
        that.getProductTypeList(),
        that.getProductList(data),
        common.getDeptArea(),
        common.getProductTypeListByFLag({ typeFlag: 1 })
      ])
        .then(
          res => {
            loading.close();
            //部门树
            let array = ["1"];
            //部门对应列表
            that.optionsDept = [
              {
                deptId: "all",
                deptName: "全选"
              }
            ].concat(res[0]);
            that.valueDept =
              res[0].length > 0
                ? that.optionsDept.map(item => {
                  return item.deptId;
                })
                : [];
            // 商品分类列表
            that.optionsProductType = [
              {
                productTypeId: "all",
                productTypeName: "全选"
              }
            ].concat(res[1]);

            // 默认商品分类全选
            that.valueProductType =
              res[1].length > 0
                ? that.optionsProductType.map(item => {
                  return item.productTypeId;
                })
                : [];


            // 区域
            that.deptAreaList = [{ id: "all", name: "全选" }].concat(res[3])
            that.areaId = that.deptAreaList.map(item => {
              return item.id
            })
            // 中类
            that.typeList1 = [{ productTypeId: "all", productTypeName: "全选" }].concat(res[4])
            that.productTypeId1 = that.typeList1.map(item => {
              return item.productTypeId
            })
            that.getDataList(true);
          },
          err => {
            loading.close();
          }
        )
        .catch(error => {
          loading.close();
        });
    },
    //定义导出Excel表格事件
    exportExcel () {
      let that = this;
      if (that.tableData.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先查找数据！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      that.centerDialogVisible = true;
      var iSpeed = 1;
      that.percentage = 0;
      that.percenttxt =
        "导出数据" + that.tableData.length + "条，已处理0条，正在导出,请稍等";
      var obj = setInterval(function () {
        iSpeed += 6;
        if (iSpeed >= 100) {
          // 设置达到多少进度后停止
          that.percentage = 100;
          that.percenttxt = "导出数据" + that.tableData.length + "条，已完成！";
          clearInterval(obj);
          setTimeout(() => {
            that.centerDialogVisible = false;
          }, 200);
        } else {
          that.percentage = iSpeed;
          that.percenttxt =
            "导出数据" +
            that.tableData.length +
            "条，已处理" +
            parseInt(that.tableData.length * (iSpeed / 100)) +
            "条，正在导出，请稍等";
        }
      }, 12); // 20毫秒后函数执行一次
      // percentage:0,
      // percenttxt:'导出数据100条,已处理50条,正在导出,请稍等',
      /* 从表生成工作簿对象 */
      // var name = document.querySelector('.el-popover');
      // var wb
      // if (name) {
      let outSpans = '#out-table2 .cell>span'
      let out = "#out-table2"
      let name = "时间段分析"
      if (that.timeFlag) {
        outSpans = '#out-table1 .cell>span'
        out = "#out-table1"
        name = "时间段分析对比"
      }
      let arr = []
      // document.querySelector("#out-table .cell>span").removeChild(name);
      $(outSpans).each(function () {
        var name = this.querySelector('.el-popover');
        arr.push(name)
        if (name) {
          this.removeChild(name);
        }
      });
      var wb = XLSX.utils.table_to_book(document.querySelector(out), {
        raw: true
      })
      var i = 0
      $(outSpans).each(function () {
        var name = arr[i]
        if (name) {
          this.appendChild(name);
        }
        i++
      });
      //1、获取所有的键组成的字符串数组：
      let keys = Object.keys(wb.Sheets.Sheet1);
      //2、随机获取一个合法的下标
      var len = Math.ceil(keys.length / 2) - 1;
      var sheet1 = wb.Sheets.Sheet1;
      //3、显示键的名字和键对应的值
      // for (var i = len; i < keys.length - 2; i++) {
      //   delete sheet1[keys[i]];
      // }
      wb.Sheets.Sheet1 = sheet1;
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          name + common.getDateDetail() + ".xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
  },
  mounted () {
    let that = this;
    that.init();
  },
  destroyed () {
    loading.close();
  }
};
</script>



// WEBPACK FOOTER //
// src/view/main/timeSaleAnalysis.vue